import apollo from '@/graphql'
import { Message } from 'element-ui'
import router from '@/router'

import BannerDetailsQuery from '@/graphql/banner/BannerDetailsQuery.gql'
import BannersQuery from '@/graphql/banner/BannersQuery.gql'
import CreateBanner from '@/graphql/banner/CreateBanner.gql'
import SaveBannerDetails from '@/graphql/banner/SaveBannerDetails.gql'
import UploadBannerBranding from '@/graphql/banner/UploadBannerBranding.gql'

function loadBannerDetails({ commit }, { id }) {
  apollo.defaultClient.query({
    query: BannerDetailsQuery,
    variables: { id: +id },
    fetchPolicy: 'network-only',
  }).then(({ data: { bannerDetails } }) => {
    commit('setBannerDetails', bannerDetails)
    commit('setEditableBannerFields', bannerDetails)
  })
}

async function loadBanners({ commit }, { storeAreasId }) {
  commit('setBannerListLoading', true)
  await apollo.defaultClient.query({
    fetchPolicy: 'network-only',
    query: BannersQuery,
    variables: { storeAreasId },
  }).then(({ data: { banners } }) => {
    commit('setBanners', banners)
    commit('setBannerListLoading', false)
  })
}

function saveBannerDetails({ state, dispatch }) {
  apollo.defaultClient.mutate({
    mutation: SaveBannerDetails,
    variables: { fields: state.editableBannerFields },
  }).then(({ data: { saveBannerDetails: { id } } }) => {
    Message({ message: 'Changes saved', type: 'success', center: false })
    dispatch('loadBannerDetails', { id })
  }).catch((err) => {
    Message.error(err.message)
  })
}

function createBanner({ state }) {
  apollo.defaultClient.mutate({
    mutation: CreateBanner,
    variables: { fields: state.editableBannerFields },
  }).then(({ data: { createBanner: { id } } }) => {
    Message({ message: 'Changes saved', type: 'success', center: false })
    router.push(`/banner/${id}`)
  }).catch((err) => {
    Message.error(err.message)
  })
}

function uploadBannerBranding({ dispatch, state }, { file }) {
  const id = state.bannerDetails.id

  return apollo
    .defaultClient
    .mutate({
      mutation: UploadBannerBranding,
      variables: { id, file },
    })
    .then((res) => {
      dispatch('loadBannerDetails', { id })
      return res
    })
}

export default {
  loadBannerDetails,
  loadBanners,
  saveBannerDetails,
  createBanner,
  uploadBannerBranding,
}



// WEBPACK FOOTER //
// ./src/store/modules/banner/banner.actions.js